import CustomForm from "@components/MainPage/CustomForm";
import Obituary from "@components/MainPage/Obituary";
import {
	Dialog,
	DialogContent,
	IconButton,
	Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import useCartStore, { SERVICE_TYPES } from "@stores/cartStore";
import useLanguageStore from "@stores/languageStore";
import { useEffect, useId, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

const MainPage = () => {
	const { t } = useTranslation();
	const [searchParams] = useSearchParams();
	const editItemId = searchParams.get("edit");
	const getItemById = useCartStore((state) => state.getItemById);
	const [properties, setProperties] = useState({});
	const [showPreview, setShowPreview] = useState(false);
	const { language } = useLanguageStore();
	const isRtl = language === "he";
	const previewTitleId = useId();

	// Load cart item data if in edit mode
	useEffect(() => {
		if (editItemId) {
			const item = getItemById(editItemId);
			if (item && item.serviceType === SERVICE_TYPES.OBITUARY) {
				setProperties(item.data || {});
			}
		}
	}, [editItemId, getItemById]);

	return (
		<div
			className={`${isRtl ? "rtl" : "ltr"}`}
			style={{
				minHeight: "calc(100vh - 64px)",
				maxWidth: "100vw",
				overflowX: "hidden",
			}}
		>
			<div className="mx-auto flex w-full max-w-6xl flex-col gap-8 py-8 md:px-6 lg:py-12">
				<section className="rounded-lg bg-white px-6 py-8 text-center md:px-10 md:py-12">
					<div className="mx-auto max-w-3xl space-y-4">
						<Typography
							variant="h4"
							component="h1"
							className="!font-extrabold"
						>
							{t("obituary.title")}
						</Typography>
						<Typography variant="body1" className="!text-lg">
							{t("obituary.description.text")}
						</Typography>
						<Typography variant="body2">
							<span className="text-red-500 font-semibold">*</span>{" "}
							{t("obituary.description.requiredFields")}
						</Typography>
					</div>
				</section>
				<div className="flex flex-col gap-6 md:flex-row">
					<CustomForm
						properties={properties}
						setProperties={setProperties}
						editItemId={editItemId}
						showPreview={showPreview}
						setShowPreview={setShowPreview}
					/>
					<div className="hidden md:flex md:flex-1 md:max-w-sm lg:max-w-md">
						<div className="flex aspect-[5/3] w-full items-stretch overflow-hidden rounded-lg border-4 border-[#063447] bg-white">
							<div className="flex-1 overflow-hidden">
								<Obituary properties={properties} />
							</div>
						</div>
					</div>
				</div>
			</div>
			<Dialog
				open={showPreview}
				onClose={() => setShowPreview(false)}
				fullScreen
				className="md:hidden"
				aria-labelledby={previewTitleId}
				PaperProps={{
					style: {
						margin: 0,
						maxHeight: "100vh",
						borderRadius: 0,
					},
				}}
			>
				<DialogContent style={{ padding: 0, overflow: "hidden" }}>
					<div style={{ position: "relative", height: "100vh" }}>
						<h2 id={previewTitleId} className="sr-only">
							{t("obituary.preview")}
						</h2>
						<IconButton
							onClick={() => setShowPreview(false)}
							style={{
								position: "absolute",
								top: 16,
								right: isRtl ? "auto" : 16,
								left: isRtl ? 16 : "auto",
								zIndex: 1000,
								backgroundColor: "rgba(255, 255, 255, 0.9)",
							}}
							aria-label={t("common.close")}
						>
							<CloseIcon />
						</IconButton>
						<Obituary properties={properties} />
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
};

export default MainPage;
